module.exports = __webpack_public_path__ + "static/img/合照4.d5ef0c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/hezhao/合照4.jpg
// module id = 4jjm
// module chunks = 1